<template>
  <div class="table-cell">
    <div class="content d-flex align-center" :class="alignClass">
      <div>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: ""
    }
  },

  computed: {
    alignClass() {
      if (this.align === "left") {
        return "justify-start";
      }
      if (this.align === "right") {
        return "justify-end";
      }
      if (this.align === "center") {
        return "justify-center";
      }
      return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.table-cell {
  display: table-cell;
  vertical-align: top;
  padding: 0 10px;
  color: #777;
  font-size: 14px;
}

.content {
  min-height: 50px;
}
</style>
